import { render, staticRenderFns } from "./ModalDataDiTrasferimento.vue?vue&type=template&id=70dcb745"
import script from "./ModalDataDiTrasferimento.vue?vue&type=script&lang=js"
export * from "./ModalDataDiTrasferimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports